import React, { useState } from 'react';
import { PasswordInactive } from 'assets/icons';
import { Input } from 'components';

interface Props {
  label: string;
  name: string;
  onChange: (e: any) => void;
}

export const PassInput = ({ label, name, onChange }: Props) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="form-group">
      <label>{ label }</label>
      <div className="input-group">
        <Input
          placeholder={label}
          type={isVisible ? 'text' : 'password'}
          name={name}
          onChange={onChange}
        />
        <div className="input-group-prepend">
          <img src={PasswordInactive} alt="Ver/Ocultar contraseña" onClick={() => setIsVisible(!isVisible)} />
        </div>
      </div>
    </div>
  )
}
